
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { confirmSwal } from '@/helper/swals';
    import Leistung from '@/types/Leistung';
    import { VCurrencyField, VForm } from '@/types/Components';
    import { DeleteLeistungPayload, LeistungenFilter, UpdateLeistungPayload } from '@/store/leistungen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('leistungen', ['loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('leistungen', ['updateLeistung', 'deleteLeistung']),
        },
    })
    export default class LeistungenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() leistung!: Leistung;
        @Prop() leistungen!: Leistung[];
        @Prop() filter!: LeistungenFilter;

        public $refs!: {
            form: VForm;
            preis: VCurrencyField;
            preis_mitarbeiter: VCurrencyField;
            preis_rektorat: VCurrencyField;
        };

        public updateLeistung!: (payload: UpdateLeistungPayload) => void;
        public deleteLeistung!: (payload: DeleteLeistungPayload) => void;

        public get isEdit(): boolean {
            return this.leistung.leistung_id !== null;
        }

        public defaultPreis = 0;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.defaultPreis = this.leistung.preis ?? 0;

                this.$nextTick(() => {
                    this.$refs.preis.setValue(this.defaultPreis);
                });

                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateLeistung({ leistung: this.leistung, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Leistung endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteLeistung({ leistung: this.leistung, filter: this.filter });
                    }
                });
        }
    }
